import React, {Component}     from 'react';
import { connect }            from 'react-redux';
import Desafios               from './desafios_lista';
import {Carousel}             from 'react-bootstrap';
import { GetAtividadesLista } from '../../../actions/atividadesAction';
import RenderFilter           from '../../../container/renderFilter';
import { SetError }           from '../../../actions/authenticActions';
import RenderTopoPag          from '../../../container/RenderTopoPag';
import { GetActionBg }        from '../../../actions/scopoAction';
import bg_desafios            from "../../../img/bg/bg_desafios.png";
import FlashCarregando        from '../../../container/FlashCarregando';
import '../../../css/aluno/styleDesafios.css';

class desafios extends Component {


    constructor(props, context) {
        super(props, context);
    
        this.handleSelect = this.handleSelect.bind(this);
    
        this.state = {
          index: 0,
          direction: null,
          load:false
        };
    }

    componentWillMount() {
      
        this.props.GetActionBg(bg_desafios);
        this.props.GetAtividadesLista(this.props.session.id,this.props.session.perfil).then((response) =>{
            this.setState({load:true});
        }).catch((error) =>{
            this.props.SetError(500);
        }); 
    }
    
    handleSelect(selectedIndex, e) {
        this.setState({
          index: selectedIndex,
          direction: e.direction
        });
    }

    render() {
        const { index, direction } = this.state;
        
        return (

            <div className="hud-middle-center active">
                <RenderTopoPag titulo="DESAFIOS"/>
                <main className="hud-middle-center-content">
                    <RenderFilter />
                    {this.state.load?<Desafios/>:<FlashCarregando/>}  
                    {/* <Carousel
                        controls={false}
                        activeIndex={index}
                        direction={direction}
                        onSelect={this.handleSelect}>

                        <Carousel.Item>
                            <Desafios />
                            <Desafios />
                            <Desafios />
                            <Desafios />
                        </Carousel.Item>

                        <Carousel.Item>
                            <Desafios />
                            <Desafios />
                            <Desafios />
                            <Desafios />
                        </Carousel.Item>

                        <Carousel.Item>
                            <Desafios />
                            <Desafios />
                            <Desafios />
                            <Desafios />
                        </Carousel.Item>

                    </Carousel> */}
                </main>
            </div>
        );
    }
}

function mapStateToProps(state) {

    return { 
            session : state.auth.session,
            menu    : state.configReducer.menu
           }
}

export default connect(mapStateToProps, {GetAtividadesLista,GetActionBg,SetError })(desafios);

// menu1="DESAFIOS INDIVIDUAIS " 
// menu1Valeu="individual" 
// menu2=" DESAFIOS COLETIVOS" 
// menu2Value="coletivos" 

// var createGroupedArray = function(arr, chunkSize) {
//     var groups = [], i;
//     for (i = 0; i < arr.length; i += chunkSize) {
//         groups.push(arr.slice(i, i + chunkSize));
//     }
//     return groups;
// }

// var arr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];
// var groupedArr = createGroupedArray(arr, 4);
// var result = JSON.stringify(groupedArr);
// result: "[[1,2,3,4],[5,6,7,8],[9,10,11,12],[13,14]]"

       {/* <Desafios/>
                           <Desafios/>
                           <Desafios/>
                           <Desafios/>
                           <Desafios/>
                           <Desafios/>
                           <Desafios/>
                           <Desafios/>
                           <Desafios/>
                           <Desafios/>
                           <Desafios/>
                           <Desafios/> */}


// WEBPACK FOOTER //
// ./src/components/aluno/desafios/desafios.js